function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFont16 = function SvgFont16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.813,
    height: 10.31
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25808",
    d: "M1.043-1.976a2.081 2.081 0 0 1 .325-1.144 2.055 2.055 0 0 1 .906-.774A13.857 13.857 0 0 0 .462-4.21 3.891 3.891 0 0 1 1.06-6.3a3.874 3.874 0 0 1 1.619-1.4 5.4 5.4 0 0 1 2.375-.5 5.071 5.071 0 0 1 2.208.457 3.528 3.528 0 0 1 1.486 1.272 3.411 3.411 0 0 1 .528 1.891v6.686H7.024v-6.439a2.059 2.059 0 0 0-.589-1.522 2.1 2.1 0 0 0-1.557-.589 3.072 3.072 0 0 0-1.469.352 1.833 1.833 0 0 0-.888.915 9.278 9.278 0 0 1 1.135.317 4.242 4.242 0 0 1 .906.422v.633a2 2 0 0 0-.941.669 1.725 1.725 0 0 0-.325 1.056v4.186H1.043z",
    transform: "translate(-.463 8.204)",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgFont16;